<template>
	<div id="flowrate">
		<div class="title">实时流量值</div>
		<ul class="tab_1">
			<li>项目名称</li>
			<li>设备名称</li>
			<li>流量值</li>
		</ul>
		<div class="scroll" ref="scroll_2">
			<div>
				<ul class="tab_2" v-for="(data,index) in flowratedata" :key="data.water_device_code">
					<li class="box_1" :class="{ change_color: index % 2 === 1 }">
						<ul class="box_2">
							<li>{{ data.dept_name }}</li>
							<li>{{ data.water_device_name }}</li>
							<li>{{ data.water_device_sjll | flowraterFliter }}m³</li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="custom-vertical-scrollbar" ref="vertical_2">
				<div class="custom-vertical-indicator"></div>
			</div>
		</div>
	</div>
</template>

<script>
//	import axios from 'axios';
	import BScroll from 'better-scroll'
	import ScrollBar from '@better-scroll/scroll-bar'
	BScroll.use(ScrollBar)
	// import bscroll from 'better-scroll'
	export default {
		data() {
			return {
				flowratedata: [],
			};
		},
		mounted() {
			// setTimeout(() => {
			// if(!this.$refs.wrapper)
			//   {
			//     return   //再加一次判断，防止dom没有加载出来而报错
			//   }
			//   this.scroll = new bscroll(this.$refs.wrapper,{})  
			//   // better-scroll的初始化接收两个参数，第一个是dom元素，第二个是配置项对象，可以不传
			// },20) 
			this.getdata();
			setInterval(() => {
				this.getdata();
			}, 60000);

		},
		methods: {
			getdata() {
				// 获取数据
				this.flowratedata = []
//				var params = new URLSearchParams();
//				params.append("deptId", "892");
//				params.append("checkCode", "3F55CAEAEAA1261CEFB7369CB6987DDB");
//				axios.post("/api/data/getRealTimeSJll", params)
//					.then((res) => {
						this.flowratedata =[{
									"water_device_code": "970850470",
									"dept_name": "智慧学院",
									"water_device_sjll": "3.5",
									"water_device_name": "生活服务区总表"
								}, {
									"water_device_code": "970850453",
									"dept_name": "智慧学院",
									"water_device_sjll": "-2.9",
									"water_device_name": "实验楼外分区"
								}, {
									"water_device_code": "970850468",
									"dept_name": "智慧学院",
									"water_device_sjll": "-4.8",
									"water_device_name": "教学行政区总表"
								}, {
									"water_device_code": "970850465",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "勤学楼外分区"
								}, {
									"water_device_code": "970850443",
									"dept_name": "智慧学院",
									"water_device_sjll": "-2.3",
									"water_device_name": "砺学楼外分区"
								}, {
									"water_device_code": "970850467",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "宿舍区泵房"
								}, {
									"water_device_code": "970850448",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "战训楼"
								}, {
									"water_device_code": "970850459",
									"dept_name": "智慧学院",
									"water_device_sjll": "4.2",
									"water_device_name": "食堂"
								}, {
									"water_device_code": "970850434",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "宿舍4栋"
								}, {
									"water_device_code": "970850424",
									"dept_name": "智慧学院",
									"water_device_sjll": "-2.6",
									"water_device_name": "战训基地"
								}, {
									"water_device_code": "970850457",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "宿舍2栋"
								}, {
									"water_device_code": "970850430",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "勤学楼"
								}, {
									"water_device_code": "970850464",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "宿舍3栋"
								}, {
									"water_device_code": "970850449",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "行政楼泵房"
								}, {
									"water_device_code": "970850460",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "宿舍1栋"
								}, {
									"water_device_code": "970850469",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "礼堂右侧消防"
								}, {
									"water_device_code": "970850447",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "砺学楼"
								}, {
									"water_device_code": "970850437",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "实验楼"
								}, {
									"water_device_code": "970850436",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "图书馆"
								}, {
									"water_device_code": "970850425",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "清雅湖边上绿化"
								}, {
									"water_device_code": "970850456",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "礼堂左侧消防"
								}, {
									"water_device_code": "868528348",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "礼堂"
								}, {
									"water_device_code": "970850426",
									"dept_name": "智慧学院",
									"water_device_sjll": "0.1",
									"water_device_name": "西门门岗及绿化"
								}, {
									"water_device_code": "970850428",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "砺学楼绿化"
								}, {
									"water_device_code": "970850438",
									"dept_name": "智慧学院",
									"water_device_sjll": "0.1",
									"water_device_name": "行政楼绿化"
								}, {
									"water_device_code": "970850458",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "宿舍区绿化"
								}, {
									"water_device_code": "990804305",
									"dept_name": "智慧学院",
									"water_device_sjll": "0",
									"water_device_name": "行政楼"
								}];
						setTimeout(() => {
							this.$nextTick(() => {
								new BScroll(this.$refs.scroll_2, {
									scrollX: false,
									scrollY: true,
									click: true,
									mouseWheel: true,
									scrollbar: {
										customElements: [this.$refs.vertical_2],
										fade: true,
										interactive: true,
										scrollbarTrackClickable: true
									}
								})
							})
						}, 300)
//					})
//					.catch((error) => {
//						console.log(error);
//					});
			}
		},
		filters: {
			flowraterFliter(item) {
				return Number(item).toFixed(1)
			}
		}
	};
</script>

<style scoped>
	#flowrate {
		margin-top: 1.48vh;
		height: 21.48vh;
		width: 100%;
		background: url("@/assets/pengshui_bg.png") no-repeat center center;
		color: #ffffff;
		background-size: 100% 100%;
	}
	
	.title {
		color: #ffffff;
		text-align: start;
		font-size: 18px;
		height: 4vh;
		line-height: 4vh;
		/* margin-top: 1vh; */
		margin-left: 1.04vw;
	}
	
	.tab_1 {
		display: flex;
		width: 95%;
		justify-content: space-evenly;
		color: #649cff;
		font-size: 12px;
		/* padding-top: 12px; */
		padding-bottom: 1.111vh;
	}
	
	.tab_1 li {
		flex: 1;
		/* height: 28px; */
	}
	
	.box_1 {
		height: 2.96vh;
		line-height: 2.96vh;
		font-size: 12px;
		width: 98%;
		margin-top: 0.46vh;
	}
	
	.box_2 {
		display: flex;
		justify-content: space-evenly;
	}
	
	.box_2 li {
		flex: 1;
	}
	
	.box_2 :nth-child(2) {
		flex: 1.2;
	}
	
	.change_color {
		background: #1e366b;
	}
	
	.scroll {
		width: 95%;
		overflow: hidden;
		height: 14.9vh;
		cursor: pointer;
		position: relative;
	}
	/* 滚动条样式 */
	/* .scroll::-webkit-scrollbar {
  width: 0.26vw;
  height: 0.925vh;
  border-radius: 3px;
} */
	/* 背景样式 */
	/* .scroll::-webkit-scrollbar-track {
  background: rgb(238, 236, 236);
  border: 1px solid gray;
} */
	/* 背景上面的条条样式 */
	/* .scroll::-webkit-scrollbar-thumb {
  background: gray;
  border-radius: 10px;
} */
</style>